import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * AppTour store with localStorage persistence
 * Manages Joyride tour state and completion tracking
 */
export const useAppTourStore = create(
  persist(
    (set, get) => ({
      // Tour state
      run: false,
      stepIndex: 0,
      tourFinished: false,
      tourKey: 0,

      // Tour completion tracking by tour ID
      completedTours: [],

      // Actions
      setStepIndex: (stepIndex) => set({ stepIndex }),

      // Set run state and step index atomically (for navigation sync)
      setRunAndStep: (run, stepIndex) => set({ run, stepIndex }),

      // Start tour (resets to beginning)
      startTour: () => {
        const { tourKey } = get();
        set({
          run: true,
          stepIndex: 0,
          tourFinished: false,
          tourKey: tourKey + 1, // Increment to force fresh Joyride instance
        });
      },

      // Complete current tour and stop
      completeTour: (tourId) => {
        const { completedTours, tourKey } = get();
        set({
          run: false,
          tourFinished: true,
          tourKey: tourKey + 1, // Increment key to force Joyride remount
          completedTours:
            tourId && !completedTours.includes(tourId)
              ? [...completedTours, tourId]
              : completedTours,
          stepIndex: 0,
        });
      },

      // Reset tour state (for new users)
      resetTour: () => {
        set({
          run: false,
          stepIndex: 0,
          tourFinished: false,
          tourKey: 0,
          completedTours: [],
        });
      },
    }),

    {
      name: 'app-tour-storage',
      version: 1,
      partialize: (state) => ({
        completedTours: state.completedTours,
        tourFinished: state.tourFinished,
        tourKey: state.tourKey,
        stepIndex: state.stepIndex,
        run: state.run,
      }),
    }
  )
);
